import React from 'react';



export function PrivacyPolicy(){
	return (
		<div class="w-full p-8 rounded-lg shadow-md">
    <h1 class="text-2xl font-semibold mb-6">Privacy Policy</h1>
    <p class="text-gray-400 mb-4">
     	Our company respects the privacy of its users and is committed to protecting the personal information you provide while using our mobile game "Flip and find". This Privacy Policy outlines the types of information we may collect from you and how we use, share, and safeguard that information.
    </p>
    <h2 class="text-xl font-semibold mb-4">Information We Collect</h2>
    <p class="text-gray-400 mb-4">
      While using the Game, we may collect the following types of information:
    </p>
    <ol class="list-decimal list-inside text-gray-400 mb-6">
      <li>Personal Information: We do not collect any personally identifiable information such as your name, address, email, or phone number.</li>
    </ol>
    <h2 class="text-xl font-semibold mb-4">How We Use Your Information</h2>
    <p class="text-gray-400 mb-4">
      The information we collect is used for the following purposes:
    </p>
    <ol class="list-decimal list-inside text-gray-400 mb-6">
      <li>Advertising: We may display advertisements within the Game. Advertisements may be targeted based on non-personal information, such as device type and gameplay data.</li>
    </ol>
    <h2 class="text-xl font-semibold mb-4">Third-Party Services</h2>
    <p class="text-gray-400 mb-4">
      We may use third-party services, such as analytics and advertising providers, to assist us in operating and analyzing the Game. These third-party services may collect and use information in accordance with their own privacy policies. We encourage you to review the privacy policies of these third-party services.
    </p>
		<h2 class="text-xl font-semibold mb-4">Children's Privacy</h2>
    <p class="text-gray-400 mb-4">
      We do not knowingly collect any personal information from children under 13 years old. If you believe we may have inadvertently collected personal information from a child under 13, please contact us immediately, and we will take steps to delete the information.
    </p>
    <h2 class="text-xl font-semibold mb-4">Data Security</h2>
    <p class="text-gray-400 mb-4">
      We take reasonable measures to protect the information we collect from loss, theft, misuse, and unauthorized access or disclosure. However, please be aware that no data transmission over the internet or electronic storage method is 100% secure, and we cannot guarantee absolute data security.
    </p>
    <h2 class="text-xl font-semibold mb-4">Changes to this Privacy Policy</h2>
    <p class="text-gray-400 mb-4">
      We reserve the right to update or modify this Privacy Policy at any time. Any changes will be effective immediately upon posting the updated Privacy Policy on the Game. Please review this page periodically to stay informed about our privacy practices.
    </p>
    <h2 class="text-xl font-semibold mb-4">Contact Us</h2>
    <p class="text-gray-400 mb-4">
      If you have any questions or concerns regarding this Privacy Policy or our data practices, please contact us at:
    </p>
    <p class="text-blue-500 font-semibold">
      omar2hmitouch@gmail.com
    </p>
  </div>
	)
}